import axios from 'axios'
import {
	USER_UPDATED,
	CLEARED_ACCOUNT_DATA,
	GOT_ACCOUNT_DATA,
	INVITES_POSTED,
	GOT_USERDATA,
	AUTH_ERROR,
	UNAUTH_USER,
	OPEN_MODAL
} from './types'

import { errorHandler } from './actions'

import { API_URL } from '../api'

import { getUserFromSelection } from 'state/selectors/userSelectors'
import { persistor } from 'index.js'

import copy from 'fast-copy'

import { doToken } from 'utils'

export function getAccountData(slug, campaign, clearExistingData, callback = null, tokenFromState = null) {
	return dispatch => {
		if (clearExistingData) {
			dispatch({
				type: CLEARED_ACCOUNT_DATA,
			})
		}

		if (tokenFromState) {
			axios.defaults.headers.common['Authorization'] = 'Bearer ' + tokenFromState
		}

		let queryUrl = `${API_URL}/accounts/getBySlug/${slug}`

		if (campaign) {
			queryUrl += `?campaign=${campaign}`
		}

		axios.get(queryUrl).then(response => {
			// we sorta mutated 'account' to get this here.
			const announcement = response.data.announcement

			delete response.data.announcement

			if (announcement) {
				dispatch({
					type: OPEN_MODAL,
					operation: 'announcement',
					dataType: null,
					data: announcement
				})
			}

			response.data.optimistic = false

			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'account',
				hardSetAll: true
			})

			dispatch({
				type: GOT_ACCOUNT_DATA,
				payload: response.data,
			})

			if (callback) {
				callback(false)
			}
		}).catch(error => {
			console.log(error)

			callback()

			if (error.response && error.response.status) {
				doToken('remove')

				persistor.purge()

				dispatch({
					type: UNAUTH_USER,
				})

				errorHandler(dispatch, error.response, AUTH_ERROR)
			}
		})
	}
}

export const touchAccount = accountId => {
	return dispatch => {
		axios.get(API_URL + '/accounts/touch/' + accountId)
			.catch(error => {
				if (error.response && error.response.status === 401) {
					doToken('remove')

					persistor.purge()

					dispatch({
						type: UNAUTH_USER,
					})

					errorHandler(dispatch, error.response, AUTH_ERROR)
				}
			})
	}
}

export function saveUser(userData, callback = null, isOtherUser = false) {
	let formData = new FormData()
	Object.keys(userData).forEach(key => formData.append(key, userData[key]))

	if (userData.imageFile) {
		formData.append('imageFile', userData.imageFile)
	}

	return dispatch => {
		// go optimistically, we don't need to wait.
		if (userData.id && !isOtherUser) {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: copy(userData),
				entityType: 'user',
			})
		}

		axios.post(API_URL + '/saveUser', formData, {
			headers: { 'content-type': 'multipart/form-data' },
		})
			.then(response => {
				if (response && response.data.token) {
					doToken('set', {
						token: response.data.token,
						userId: userData.id
					}, { path: '/' })
				}

				if (!isOtherUser) {
					dispatch({
						type: USER_UPDATED,
						payload: response.data.id
					})
				}

				if (!userData.invitation) {
					dispatch({
						type: 'ENTITY_ADDED_OR_UPDATED',
						payload: copy(response.data),
						entityType: 'user',
					})
				}

				if (callback) {
					callback(response)
				}
			})
			.catch(error => {
				console.log(error)

				if (callback) {
					callback(error.response)
				}
			})
	}
}

export function updatePreferences(preferencesObject, callback) {
	return dispatch => {
		axios.post(API_URL + '/user/updatePreferences', preferencesObject)
			.then(response => {
				callback();

				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'user',
				})
			})
	}
}

export function updateStaffMember(user, data, callback) {
	return dispatch => {
		axios.post(API_URL + '/user/updateStaffMember/' + user.id, data)
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'account',
				})

				callback()
			})
			.catch(error => {
				console.log(error)
			})
	}
}

export function saveAccount(requestData, callback) {
	let formData = new FormData()
	Object.keys(requestData).forEach((key) => {
		formData.append(key, requestData[key]);
	})

	if (requestData.imageFile) {
		formData.append('imageFile', requestData.imageFile)
	}

	let id = requestData.id ? requestData.id : 'null'

	return dispatch => {
		axios.post(API_URL + '/accounts/' + id + '/save', formData, {
			headers: { 'content-type': 'multipart/form-data' },
		}).then(response => {
			let userId = requestData.user_id

			getUserFromSelection(response.data.users, userId)

			dispatch({
				type: GOT_USERDATA,
				payload: userId
			})

			response.data.users.forEach(user => {
				if (!user.accounts || !user.accounts.length) {
					user.accounts = [{
						id: response.data.id
					}]
				}
			})

			dispatch({
				type: GOT_ACCOUNT_DATA,
				payload: response.data,
				isSecondaryAccount: requestData.isSecondaryAccount
			})

			callback(null, response)
		})
			.catch(error => {
				console.log(error)
				callback(error.response, null)
			})
	}
}

export function postInvites(inviteData, isGuest, callback) {
	return dispatch => {
		axios.post(API_URL + '/invitations/post', { inviteData, isGuest })
			.then(response => {
				dispatch({
					type: INVITES_POSTED,
					payload: response.data
				})

				callback()
			}).catch(error => {
				console.log(error);
				//errorHandler(dispatch, error.response, AUTH_ERROR);
			});
	}
}

export function resendInvite(inviteId) {
	return dispatch => {
		axios.post(API_URL + '/invitations/resend/' + inviteId)
			.catch(error => {
				console.log(error)
			})
	}
}

export function postSearch(term, account, callback) {
	return dispatch => {
		axios.post(API_URL + '/search', { term, account_id: account.id }).then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'searchData',
			})

			callback(response.data)
		}).catch(error => {
			console.log(error)
		})
	}
}

export function openHeaderTab(slug) {
	return dispatch => {
		dispatch({
			type: 'HEADER_TAB_CHANGED',
			payload: slug
		})
	}
}

export function getStorageQuota(accountId, callback) {
	return dispatch => {
		axios.get(API_URL + '/accounts/storageQuota/' + accountId).then(response => {
			const totalSize = response.data

			const totalSizeInMb = Math.round(totalSize / 1000000)

			callback(totalSizeInMb)
		}).catch(error => {
			console.log(error)
		})
	}
}

export function deleteOrganisation(data, callback) {
	const account = data.id ? data : data.account
	const reason = data.reason || null

	return dispatch => {
		dispatch({
			type: 'ENTITY_DELETED',
			entityType: 'account',
			payload: account,
		})

		axios.post(API_URL + '/accounts/delete', {
			account,
			reason

		}).catch(error => {
			console.log(error)
		})

		callback()
	}
}

export const postAnnouncement = (announcement, accountId, callback) => {
	return dispatch => {
		// the API calls it bulletin for now.
		axios.post(API_URL + '/bulletin/post', { announcement, accountId })
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'bulletin',
				})

				callback()
			}).catch(error => {
				console.log(error)
			})
	}
}

export const dismissAnnouncement = (announcement, user) => {
	return dispatch => {
		const last_dismissed_bulletin_ids = user.last_dismissed_bulletin_ids ? copy(user.last_dismissed_bulletin_ids) : {}

		last_dismissed_bulletin_ids[announcement.account_id] = announcement.id

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...user,
				last_dismissed_bulletin_ids
			},
			entityType: 'user',
		})

		axios.post(API_URL + '/bulletin/' + announcement.id + '/dismiss')
	}
}

export const likeAnnouncement = (announcement, user) => {
	return dispatch => {
		const likerIds = announcement.liker_ids ? [...announcement.liker_ids] : []
		const likerIndex = likerIds.indexOf(user.id)

		if (likerIndex !== -1) {
			likerIds.splice(likerIndex, 1)
		} else {
			likerIds.push(user.id)
		}

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...announcement,
				liker_ids: likerIds
			},
			entityType: 'bulletin',
		})

		axios.post(API_URL + '/bulletin/' + announcement.id + '/like')
			.catch(error => {
				console.log(error)
			})
	}
}

export const saveEvent = (event, account, callback) => {
	return dispatch => {
		if (!event.account_id) {
			event.account_id = account.id
		}

		axios.post(API_URL + '/accounts/saveEvent', event)
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'event',
				})

				callback()
			}).catch(error => {
				console.log(error)
			})
	}

}

export const getStakeholdersAndPurposes = accountId => {
	return dispatch => {
		axios.get(API_URL + '/accounts/' + accountId + '/stakeholdersAndPurposes')
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'account',
				})
			}).catch(error => {
				console.log(error)
			})
	}
}

export const saveStakeholder = (data, callback) => {
	return dispatch => {
		axios.post(API_URL + '/stakeholder/save', { data })
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'stakeholder',
				})

				callback(response.data)
			}).catch(error => {
				console.log(error)
				callback()
			})
	}
}

export const getStakeholderData = id => {
	return dispatch => {
		axios.get(API_URL + '/stakeholder/' + id)
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'stakeholder',
				})
			}).catch(error => {
				console.log(error)
			})
	}
}

export const getAccountMeetings = (id, callback) => {
	return dispatch => {
		axios.get(API_URL + '/accounts/' + id + '/meetings')
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'account',
				})

				callback()
			}).catch(error => {
				console.log(error)
			})
	}
}

export const setUnseenNotifications = number => {
	return dispatch => {
		dispatch({
			type: 'SET_UNSEEN_NOTIFICATIONS',
			payload: number
		})
	}
}

export const saveBillingDetails = (data, accountId, callback) => {
	return dispatch => {
		axios.post(API_URL + '/accounts/' + accountId + '/saveBillingDetails', data)
			.then(response => {
				callback()

				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'account',
				})
			}).catch(error => {
				console.log(error)
				callback(error)
			})
	}
}

export const validateCoupon = (code, callback) => {
	return () => {
		axios.post(API_URL + '/accounts/validateCoupon', { code })
			.then(response => {
				callback(response.data, code)
			}).catch(error => {
				console.log(error)

				callback(false)
			})
	}
}

export const cancelPremium = (account, callback) => {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...account,
				package_id: 1,
				isPremium: false
			},
			entityType: 'account',
		})

		axios.post(API_URL + '/accounts/' + account.id + '/cancelPremium')
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'account',
				})

				if (callback) {
					callback()
				}
			}).catch(error => {
				console.log(error)

				if (callback) {
					callback()
				}
			})
	}
}

export const getInvoices = account => {
	return dispatch => {
		axios.get(API_URL + '/accounts/' + account.id + '/invoices')
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'account',
				})
			}).catch(error => {
				console.log(error)
			})
	}
}

export const extendTrial = account => {
	return dispatch => {
		axios.post(API_URL + '/accounts/' + account.id + '/extendTrial')
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'account'
				})
			}).catch(error => {
				console.log(error)
			})
	}
}

export const purgeData = () => {
	return dispatch => {
		persistor.purge()
	}
}


// WEBPACK FOOTER //
// ./src/state/actions/account-actions.jsx